import React from 'react';

export interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * The content of the button, typically text or HTML Content.
   */
  children?: React.ReactNode;

  /**
   * Additional CSS class for the button, allowing for custom styling.
   */
  className?: string;

  /**
   * Defines the visual variant of the button, such as 'contained', 'outlined', or 'text'.
   */
  variant?: keyof typeof ButtonVariant;

  /**
   * Specifies the style type of the button, typically used to indicate primary, secondary, etc.
   */
  styleType?: keyof typeof ButtonStyle;

  /**
   * Sets the size of the button, such as 'small', 'medium', or 'large'.
   */
  size?: keyof typeof ButtonSize;
}

export enum ButtonVariant {
  text = 'text',
  contained = 'contained',
  outlined = 'outlined',
}

export enum ButtonStyle {
  primary = 'primary',
  secondary = 'secondary',
  danger = 'danger',
  success = 'success',
}

export enum ButtonSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  xlarge = 'xlarge',
}
